import React from "react";
import { Modal, Input, Table, Popover, Button, DatePicker, } from "antd";
import {AddWasteProfile} from "./AddWasteProfile";
import {AddUpdateHotSheetForm} from "../../tracks/hotsheet/popups/AddUpdateHotSheet";
import {AddUpdateHotSheet} from "../../tracks/hotsheet/popups/AddUpdateHotSheet";

const {RangePicker} = DatePicker;
const Search = Input.Search;
const content = (
    <div className="action-column action-dropdown">
      <a title="View"><i className="fa fa-eye" /></a>
      <a title="Edit"><i className="fa fa-pencil" /></a>
      <a title="Print"><i className="icon-printer" /></a>
    </div>
);

export class ProposalAccount extends React.Component {

columns = [
  {
    title: 'Proposal Number',
  dataIndex: 'proposal_num',
  key: 'proposal_num',
}, {
  title: 'Estimator Info',
  dataIndex: 'estimator',
  key: 'estimator',
},{
  title: 'Site',
  dataIndex: 'site',
  key: 'site',
},{
  title: 'Bill To',
  dataIndex: 'bill_to',
  key: 'bill_to',
},{
  title: 'User',
  dataIndex: 'user',
  key: 'user',
},{
  title: 'Scope',
  dataIndex: 'scope',
  key: 'scope',
},{
  title: 'Status',
  dataIndex: 'status',
  key: 'status',
},{
    title: 'Action',
    render: item => <div className="action-column">
      <a title="View"><i className="fa fa-eye" /></a>
      <a title="Edit"><i className="fa fa-pencil" /></a>
      <a title="Print"><i className="icon-printer" /></a>
    </div>
  },
];

 data = [{
   key: '1',
   proposal_num: '562145',
   estimator:'Demo Estimate',
   site:<div>Test<br/>ID: <span>16988</span></div>,
   bill_to:<div>Test<br/>ID: <span>16988</span></div>,
   user:'Mike Rosati',
   scope:'US Removal',
   status:<span className="completed"><i className="fa fa-circle"/></span>,
},{
   key: '2',
   proposal_num: '562145',
   estimator:'Demo Estimate',
   site:<div>Test<br/>ID: <span>16988</span></div>,
   bill_to:<div>Test<br/>ID: <span>16988</span></div>,
   user:'Mike Rosati',
   scope:'US Removal',
   status:<span className="completed"><i className="fa fa-circle"/></span>,
},{
   key: '3',
   proposal_num: '562145',
   estimator:'Demo Estimate',
   site:<div>Test<br/>ID: <span>16988</span></div>,
   bill_to:<div>Test<br/>ID: <span>16988</span></div>,
   user:'Mike Rosati',
   scope:'US Removal',
   status:<span className="completed"><i className="fa fa-circle"/></span>,
},{
   key: '4',
   proposal_num: '562145',
   estimator:'Demo Estimate',
   site:<div>Test<br/>ID: <span>16988</span></div>,
   bill_to:<div>Test<br/>ID: <span>16988</span></div>,
   user:'Mike Rosati',
   scope:'US Removal',
   status:<span className="completed"><i className="fa fa-circle"/></span>,
},];

  render() {
    const { visible } = this.props;
    const rowSelection = {
      onChange: this.onCheckboxSelectChange,
    };
    return (
      <Modal closable={false} centered visible={visible} onOk={() => this.props.onCancel()}
             onCancel={() => this.props.onCancel()} width='75%' className="view-data-modal view-hotsheet-mdl">
            <div className="row m-0">
              <div className="col-sm-6 col-12 view-modal-header">
                <h3><span>Proposal</span></h3>
              </div>
            </div>
            <div className="row clearfix edit-header">
              <div className="col-sm-4 col-12">
                <div id="date_range_wrapper">
                  <RangePicker width={"100%"} />
                </div>
              </div>
              <div className="col-sm-2 col-2 padding-0">
                <button className="btn theme-btn xs-hide" type="button" >Create Proposal</button>
                <button className="btn theme-btn xs-show" type="button"><i
                  className="fa fa-plus" /></button>
              </div>
              <div className="col-sm-3 col-10">
                <Search placeholder="Input search text" style={{ width: "100%" }} />
              </div>
             <div className="col-sm-3 col-12 text-right">
               <Button className="advance-search-btn">Advance</Button>
               <Button className="advance-search-btn"><i className="fa fa-repeat" /> </Button>
              </div>
              <div className="col-12 edit-div text-right">
                <span>5 Records</span>
                <button className="btn btn-edit" title="Trash">
                  <i className="fa fa-trash-o" />
                </button>
                <button type="primary" className="btn btn-edit">
                  <i className="fa fa-print" />
                </button>
                <button type="primary" className="btn btn-edit">
                  <i className="fa fa-eye" />
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="listing-table">
                  <Table rowSelection={rowSelection} className="responsive-table table table-hover waste-profile-tbl" columns={this.columns} dataSource={this.data} />
                </div>
              </div>
            </div>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/popups/ProposalAccount.jsx